angular.module("app").directive("hasPermission", [
    "settingsService",
    "$timeout",
    function (settingsService, $timeout) {
        return {
            restrict: "A",
            link: function (scope, element) {
                var settings = settingsService.getSettings();
                scope.$on("menu:rendered", function () {
                    if (!!settings && angular.isArray(settings.menuVisibleStates)) {
                        $timeout(function () {
                            $(element).find("a[ui-sref]").each(function () {
                                !checkPermission($(this).attr("class") && $(this).attr("class").split(" ") || []) && $(this).remove();
                            });
                            $(element).find("li").filter(function () {
                                return $(this).find("a[ui-sref]").length === 0
                            }).remove();
                            $(element).show();
                        })
                    }
                });
            }
        };

        function checkPermission (elementClasses) {

            while(elementClasses[0]) {
                if (settingsService.getSettings().menuVisibleStates.indexOf(elementClasses[0]) != -1) {
                    return true
                }
                elementClasses.shift();
            }

            return false
        }
    }
]).directive("checkPermission", [
    "settingsService",
    function (settingsService) {
        return {
            restrict: "A",
            compile: function (element, attrs) {
                !checkPermission(attrs.class && attrs.class.split(" ") || []) && $(element).remove();
            }
        };

        function checkPermission (elementClasses) {

            while(elementClasses[0]) {
                if (settingsService.getSettings().menuVisibleStates.indexOf(elementClasses[0]) != -1) {
                    return true
                }
                elementClasses.shift();
            }

            return false
        }
    }
]);